import { useState, useRef, useEffect, useMemo } from "react";
import { DateRange } from "react-date-range";
import { format } from "date-fns";
import { NavLink } from "react-router-dom";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { getPayoutPendingSummary } from "../../config/LiveApi";

function TransactionGetData() {
  const [showPicker, setShowPicker] = useState(false);
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState([]);

  // ✅ NEW FILTER STATES
  const [pg, setPg] = useState("");
  const [orgName, setOrgName] = useState("");
  const [name, setName] = useState("");
  const [groupBy, setGroupBy] = useState("orgName,pg");

  const pickerRef = useRef(null);

  const [dateRange, setDateRange] = useState([
    { startDate: new Date(), endDate: new Date(), key: "selection" },
  ]);


  // Convert date to UTC
  const getUtcRangeFromIST = () => {
    const start = new Date(dateRange[0].startDate);
    start.setHours(0, 0, 0, 0);

    const end = new Date(dateRange[0].endDate);
    end.setHours(23, 59, 59, 999);

    return {
      startDate: start.toISOString(),
      endDate: end.toISOString(),
    };
  };

  // ✅ Fetch API WITH ALL PARAMS
const fetchSummaryData = async () => {
  try {
    setLoading(true);

    const { startDate, endDate } = getUtcRangeFromIST();

    const res = await getPayoutPendingSummary({
      startDate,
      endDate,
      pg: pg || undefined,
      orgName: orgName || undefined,
      name: name || undefined,
      groupBy: groupBy || undefined,
    });

    setSummary(res?.data || []);
  } catch (err) {
    alert(err?.response?.data?.message || "Failed to fetch data");
  } finally {
    setLoading(false);
  }
};

  // Close date picker
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target)) {
        setShowPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Dynamic headers
  const tableHeaders = useMemo(() => {
    return summary.length > 0 ? Object.keys(summary[0]) : [];
  }, [summary]);

  // Dynamic total
  const totalPending = useMemo(() => {
    if (!summary.length) return null;
    if (!summary[0].hasOwnProperty("pendingCount")) return null;

    return summary.reduce(
      (acc, row) => acc + (Number(row.pendingCount) || 0),
      0
    );
  }, [summary]);

  // Styles
  const thStyle = {
    padding: "12px",
    border: "1px solid #eee",
    fontWeight: "600",
  };

  const tdStyle = {
    padding: "10px",
    border: "1px solid #eee",
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <nav className="navbar-accounts">
        <div className="nav-links-accounts">
          <NavLink to="/payout-pending-summary">
            Fetch Data and Download
          </NavLink>
          <NavLink to="/payout-pending-data" className="active-accounts">
            Get Data
          </NavLink>
          <NavLink to="/failed-pending-payout">Failed Txn</NavLink>
          <NavLink to="/retry-callback">Retry Callback</NavLink>
        </div>
      </nav>
      <h2>Transaction Pending Payout Data</h2>

      {/* FILTER SECTION */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "15px",
          marginBottom: "20px",
        }}
      >
        {/* Date */}
        <div style={{ position: "relative" }}>
          <label>Date Range</label>
          <div
            onClick={() => setShowPicker(!showPicker)}
            style={{
              padding: "8px",
              border: "1px solid #ccc",
              cursor: "pointer",
              background: "#fafafa",
            }}
          >
            {format(dateRange[0].startDate, "dd MMM yyyy")} —{" "}
            {format(dateRange[0].endDate, "dd MMM yyyy")}
          </div>

          {showPicker && (
            <div ref={pickerRef} style={{ position: "absolute", zIndex: 10 }}>
              <DateRange
                ranges={dateRange}
                onChange={(item) => {
                  setDateRange([item.selection]);
                  setShowPicker(false);
                }}
              />
            </div>
          )}
        </div>

        {/* PG */}
        {/* <input
          type="text"
          placeholder="PG"
          value={pg}
          onChange={(e) => setPg(e.target.value)}
          style={{ padding: "8px", border: "1px solid #ccc" }}
        /> */}

        {/* Org Name */}
        {/* <input
          type="text"
          placeholder="Org Name"
          value={orgName}
          onChange={(e) => setOrgName(e.target.value)}
          style={{ padding: "8px", border: "1px solid #ccc" }}
        /> */}

        {/* Name */}
        {/* <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{ padding: "8px", border: "1px solid #ccc" }}
        /> */}

        {/* Group By */}
        <input
          type="text"
          placeholder="Group By (orgName,pg,name)"
          value={groupBy}
          onChange={(e) => setGroupBy(e.target.value)}
          style={{
            padding: "8px",
            border: "1px solid #ccc",
            width: "220px",
            marginTop: "20px",
          }}
        />

        <button
          onClick={fetchSummaryData}
          disabled={loading}
          style={{
            padding: "8px 20px",
            background: "#fc8019",
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
        >
          {loading ? "Loading..." : "Fetch"}
        </button>
      </div>

      {/* TABLE */}
      {summary.length > 0 && (
        <div
          style={{
            overflowX: "auto",
            background: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr style={{ background: "#fc8019", color: "#fff" }}>
                <th style={thStyle}>#</th>
                {tableHeaders.map((header) => (
                  <th key={header} style={thStyle}>
                    {header.toUpperCase()}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {summary.map((row, index) => (
                <tr key={index} style={{ textAlign: "center" }}>
                  <td style={tdStyle}>{index + 1}</td>
                  {tableHeaders.map((header) => (
                    <td key={header} style={tdStyle}>
                      {row[header]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>

            {totalPending !== null && (
              <tfoot>
                <tr style={{ fontWeight: "bold", textAlign: "center" }}>
                  <td colSpan={tableHeaders.length} style={tdStyle}>
                    Total
                  </td>
                  <td style={tdStyle}>{totalPending}</td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      )}
    </div>
  );
}

export default TransactionGetData;